/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled from 'styled-components';
import theme from './Title.theme';

export const Title = styled('div')<{ $hasMarginBottom?: boolean }>`
  color: ${props => theme(props).color};
  display: flex;
  flex-direction: column;
  ${props =>
    props.$hasMarginBottom &&
    `
    margin-bottom: 1rem;
  `};

  .title {
    color: ${props => theme(props).color};
    font-size: ${props => theme(props).titleFontSize};
    font-weight: 600;
    line-height: ${props => theme(props).titleLineHeight};
  }

  .subtitle {
    font-size: ${props => theme(props).subtitleFontSize};
    line-height: ${props => theme(props).subtitleLineHeight};
  }

  .subtitlePurple {
    font-size: ${props => theme(props).subtitleFontSize};
    line-height: ${props => theme(props).subtitleLineHeight};
    font-weight: 600;
    margin: 0.75rem 0;
  }

  .black-subtitle {
    color: ${props => theme(props).blackSubtitleColor};
    font-size: ${props => theme(props).blackSubtitleFontSize};
    font-weight: 600;
    margin: 0.75rem 0;
  }
`;
